<template>
  <div id="contentNotice" class="container notice">
    <div class="board_title">공지사항</div>
    <table class="bbs_table_1">
      <colgroup>
        <col />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <thead>
        <th>No</th>
        <th>제목</th>
        <th>등록자</th>
        <th>작성일</th>
        <th class="views">조회수</th>
      </thead>
      <tbody v-if="contentNoticeData.length !== 0">
        <tr v-for="(item, index) in contentNoticeData.content" :key="index">
          <td class="no">
            <!-- {{ contentNoticeData }} -->
            {{
              contentNoticeData.page_info.total_size -
              (contentNoticeData.page_info.request_page - 1) *
                contentNoticeData.page_info.request_size -
              index
            }}
          </td>
          <td class="text_left">
            <a @click="getNoticeIdx(item.idx)" v-html="item.title"></a>
          </td>
          <td v-html="item.author"></td>
          <td>{{ item.created_at.split(' ')[0] }}</td>
          <td>{{ item.view }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td class="nonotu" colspan="6">공지사항이 없습니다.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="bbs_paging">
    <div class="container">
      <ul>
        <li>
          <a id="prevPage"
            ><img src="/assets/images/icon/page-arrow-left.png" alt=""
          /></a>
        </li>
        <li
          v-for="(page_data, pageIndex) in pageArray.total_pages"
          :key="pageIndex"
        >
          <a
            class="num"
            :class="{ on: page_data == pageArray.request_page }"
            @click="getData(page_data)"
            >{{ page_data }}</a
          >
        </li>
        <li>
          <a id="nextPage"
            ><img src="/assets/images/icon/page-arrow-right.png" alt=""
          /></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { loadDetailContentNotice } from '../api/boards'

export default {
  name: 'ContentsNotice',
  setup() {
    const route = useRoute()
    const router = useRouter()

    const contentId = route.params.contentsId
    const contentNoticeData = ref([])
    const pageArray = ref([])
    const page = ref(0)
    const totalPage = ref('')
    const currentPage = ref('')

    // eslint-disable-next-line no-shadow
    const getData = async (page) => {
      try {
        const response = await loadDetailContentNotice(page, contentId)
        // console.log(response)
        if (response.status_code === 200) {
          contentNoticeData.value = response
          pageArray.value = response.page_info
          totalPage.value = response.page_info.total_pages
          currentPage.value = response.page_info.request_page
        }
      } catch (err) {
        console.log(err)
      }
    }

    const getNoticeIdx = async (noticeId) => {
      router.push(`/contents/${contentId}/notice/${noticeId}`)
    }

    onMounted(() => {
      getData()
    })

    return {
      getData,
      getNoticeIdx,
      contentNoticeData,
      pageArray,
      page,
      totalPage,
      currentPage,
    }
  },
  //   setup() {
  //     const router = getCurrentInstance().proxy.$router

  //     const route = useRoute()
  //     const contentsId = ref(null)
  //     const contentNoticeData = ref(null)
  //     const cNoticeData = ref([])
  //     const cNoticePageData = ref([])
  //     const noticeErr = ref([])

  //     const getData = async () => {
  //       contentsId.value = route.params.contentsId
  //       const response = await loadDetailContentNotice(contentsId.value)
  //       if (response.data) {
  //         contentNoticeData.value = response.data
  //         cNoticePageData.value = response.data.page_info
  //       } else {
  //         // console.log(response.response.data);
  //         noticeErr.value = response.response.data
  //       }
  //     }
  //     // eslint-disable-next-line no-shadow
  //     const getIdx = async (contentsId, noticeId) => {
  //       router.push(`/contents/${contentsId}/notice/${noticeId}`)
  //     }
  //     onMounted(() => {
  //       getData()
  //     })
  //     watch(() => route.params, getData)

  //     return {
  //       contentsId,
  //       contentNoticeData,
  //       cNoticeData,
  //       cNoticePageData,
  //       getData,
  //       getIdx,
  //     }
  //   },
}
</script>
